import type { CSSObject } from '@mantine/core';
import { createStyles } from '@mantine/core';
import { ENTITY_NODE_WIDTH } from '../EntityNode/EntityNode.constants';
import {
	ENTITY_NODE_HEADER_PADDING_X,
	ENTITY_NODE_HEADER_PADDING_Y,
} from './EntityNodeHeader.constants';

export const useStyles = createStyles((theme) => ({
	wrapper: {
		cursor: 'pointer',
		flexGrow: '1 !important' as CSSObject['flexGrow'],
		flexWrap: 'nowrap',
		alignItems: 'center',
		justifyContent: 'space-between',
		overflow: 'hidden',
		width: ENTITY_NODE_WIDTH,
		gap: theme.spacing.xs,
		padding: `${ENTITY_NODE_HEADER_PADDING_Y}px ${ENTITY_NODE_HEADER_PADDING_X}px`,
	},
	content: {
		flexGrow: '1 !important' as CSSObject['flexGrow'],
		flexWrap: 'nowrap',
		justifyContent: 'space-between',
		gap: 0,
	},
	text: {
		width: theme.other.space[80],
		gap: 0,
	},
	actions: {
		flexWrap: 'nowrap',
		gap: 0,
	},
}));
